import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { fmtDate } from '@/lib/format';

const actionColor = {
  CREATE: 'text-emerald-500', UPDATE: 'text-blue-500', DELETE: 'text-rose-500',
  SOFT_DELETE: 'text-rose-500', CANCEL: 'text-amber-500', UPLOAD: 'text-cyan-500',
  LOGIN: 'text-emerald-500', LOGOUT: 'text-muted-foreground', LOGIN_GOOGLE: 'text-emerald-500',
  REGISTER_COMPANY: 'text-emerald-500',
};

export default function AuditPage() {
  const { data } = useQuery({ queryKey: ['audit'], queryFn: async () => (await api.get('/audit-logs', { params: { page_size: 200 } })).data });
  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground font-mono">Segurança & Rastreabilidade</div>
        <h1 className="text-3xl font-heading font-bold tracking-tight">Log de Auditoria</h1>
      </div>
      <Card className="border-border/70 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/40 border-b"><tr className="text-left text-[10px] uppercase font-mono text-muted-foreground"><th className="px-4 py-3">Data/Hora</th><th className="px-4 py-3">Usuário</th><th className="px-4 py-3">Ação</th><th className="px-4 py-3">Entidade</th><th className="px-4 py-3">IP</th></tr></thead>
          <tbody>
            {(data?.items || []).map((l) => (
              <tr key={l.id} className="border-b border-border/50 hover:bg-muted/30 transition-colors">
                <td className="px-4 py-3 font-mono text-xs">{new Date(l.created_at).toLocaleString('pt-BR')}</td>
                <td className="px-4 py-3">{l.user_email || '—'}</td>
                <td className={`px-4 py-3 font-mono text-xs font-semibold ${actionColor[l.action] || ''}`}>{l.action}</td>
                <td className="px-4 py-3">
                  <span className="text-xs uppercase font-mono text-muted-foreground">{l.entity}</span>
                  {l.entity_id && <span className="ml-2 text-xs font-mono text-muted-foreground/70">{l.entity_id.slice(0, 8)}</span>}
                </td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{l.ip || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
